import { render, staticRenderFns } from "./TextSpeachDescription.vue?vue&type=template&id=d9507700&"
import script from "./TextSpeachDescription.vue?vue&type=script&lang=js&"
export * from "./TextSpeachDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports